import applicatoinStyles from '/stylesheets/application.scss?inline';

let template = document.createElement('template');
template.innerHTML = /*html*/ `
  <style>
    ${applicatoinStyles}

    :host {
      display: flex;
      background-color: var(--gg-fogg-nav);
      padding: .5rem .5rem 1rem .5rem;
      box-shadow: .5rem .5rem .5rem .5rem rgba(0,0,0,.25) !important;
      position: relative;
    }

    primary-actions {
      display: flex;
      width: 100%;
      justify-content: space-between;
    }

    a:active > i {
      color: var(--gg-app-primary-dark)!important;
    }

    primary-actions .primary-action {
      display: flex;
      flex-direction: column;
      text-align: center;
      max-width: 20%;
      min-width: 18%;
      text-decoration: none;
      color: var(--gg-fogg-label);
    }

    primary-actions .primary-action.active action-label{
      font-weight: 600;
    }

    primary-actions .primary-action.active i{
      color: var(--gg-fogg-primary-active);
    }

    primary-actions .primary-action.active  .fa-triangle-exclamation{
      color: var(--gg-fogg-primary)!important;
    }

    primary-actions .primary-action i {
      font-size: 2rem;
      padding-bottom: 0.25rem;
      color: var(--gg-fogg-primary);
    }

    primary-actions .primary-action action-label {
      font-size: 0.75rem;
    }

  </style>

  <primary-actions>
    <a href="index.html" class="primary-action" aria-label="Foods of Garden Grove Home">
      <i class="fa-kit fa-fogg-home" aria-hidden="true"></i>
      <action-label>
        Home
      </action-label>
    </a>

    <a href="explore.html" class="primary-action" aria-label="Explore">
      <i class="fa fa-search" aria-hidden="true"></i>
      <action-label>
        Explore
      </action-label>
    </a>

    <a href="quests.html" class="primary-action" aria-label="Quests">
      <i class="fa-kit fa-quest" aria-hidden="true"></i>
      <action-label>
        Quests
      </action-label>
    </a>

    <a href="profile.html" class="primary-action" aria-label="Profile">
      <i class="fa-kit fa-profile" aria-hidden="true"></i>
      <action-label>
        Foodie
      </action-label>
    </a>

    <!--
    <a href="/fogg/foodcation.html" class="primary-action" aria-label="Foodcation">
      <i class="fa-solid fa-bed" aria-hidden="true"></i>
    </a>
    -->

  </primary-actions>
`;

customElements.define('bottom-nav-fogg', class extends HTMLElement {
  constructor() {
    super();

    this.attachShadow({
      mode: 'open'
    });
    this.shadowRoot.appendChild(template.content.cloneNode(true));

  }

  connectedCallback() {
    let anchors = this.shadowRoot.querySelectorAll('a');
    var current = location.pathname.split('/').pop();
    
    if (current !== '') {
      anchors.forEach((l) => {
        if (l.getAttribute('href').indexOf(current) !== -1) {
          l.classList.add('active');
          l.setAttribute('aria-current','page');
        }
      });
    }
  }
});
